/* One More Cookie site scripts. Cached by the browser and loaded deferred (after Dawn's own scripts). */

/* ---- cart guard: same-day fee, checkout checks, empty-cart fix ---- */
    (function () {
      if (window.__omcCartGuard) return;
      window.__omcCartGuard = true;

      var FEE_SCRIPT = document.currentScript;
      var FEE_VARIANT = FEE_SCRIPT ? parseInt(FEE_SCRIPT.getAttribute('data-fee-variant'), 10) || 0 : 0;
      if (!FEE_VARIANT) return;


      /* Put the fee in the SAME request as a same-day product.
         Without this the product is added first and the fee a moment later, so the fee line pops into the cart
         about a second after the product. Dawn sends one item per add-to-cart request, so for a same-day add we
         turn that request into a two-item one (product + fee). Everything else passes through untouched. */
      var nativeFetch = window.fetch;

      function isCartAdd(input) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          return /\/cart\/add(\.js)?$/.test(new URL(url, window.location.href).pathname);
        } catch (error) {
          return false;
        }
      }

      function feeLineShown() {
        return !!document.querySelector('cart-drawer-items a[href*="/products/same-day-delivery"], cart-items a[href*="/products/same-day-delivery"]');
      }

      function bundle(formData) {
        var id = formData.get('id');
        if (!id) return null;
        var out = new FormData();
        out.append('items[0][id]', id);
        out.append('items[0][quantity]', formData.get('quantity') || '1');
        formData.forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match) {
            out.append('items[0][properties][' + match[1] + ']', value);
          } else if (key === 'selling_plan') {
            out.append('items[0][selling_plan]', value);
          }
        });
        out.append('items[1][id]', String(FEE_VARIANT));
        out.append('items[1][quantity]', '1');
        ['sections', 'sections_url'].forEach(function (key) {
          if (formData.has(key)) out.append(key, formData.get(key));
        });
        return out;
      }

      /* Dawn paints the drawer from response.sections. Make sure a bundled response always carries them. */
      function ensureSections(response) {
        return response.clone().json().then(function (data) {
          if (!data || data.status || data.sections) return response;
          return nativeFetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              data.sections = sections;
              return new Response(JSON.stringify(data), {
                status: response.status,
                statusText: response.statusText,
                headers: { 'Content-Type': 'application/json' }
              });
            });
        }).catch(function () { return response; });
      }

      window.fetch = function (input, init) {
        try {
          if (
            init && init.body instanceof FormData &&
            isCartAdd(input) &&
            init.body.get('properties[_delivery_type]') === 'Same Day' &&
            !feeLineShown()
          ) {
            var bundled = bundle(init.body);
            if (bundled) {
              var next = {};
              Object.keys(init).forEach(function (key) { next[key] = init[key]; });
              next.body = bundled;
              return nativeFetch.call(this, input, next).then(ensureSections);
            }
          }
        } catch (error) {}
        return nativeFetch.apply(this, arguments);
      };

      var chain = Promise.resolve();

      function pad(n) { return String(n).padStart(2, '0'); }

      function isFee(item) {
        return item.variant_id === FEE_VARIANT || item.handle === 'same-day-delivery';
      }

      function isSameDay(item) {
        return !isFee(item) && item.properties && item.properties['_delivery_type'] === 'Same Day';
      }

      function missingDelivery(item) {
        return !isFee(item) && !(item.properties && item.properties['_delivery_type']);
      }

      /* Hampers need every cookie tin flavour chosen before they can be bought. */
      var HAMPER_TINS = { 'single-tin-hamper': 1, 'double-tin-hamper': 2 };

      function missingTins(item) {
        var count = HAMPER_TINS[item.handle];
        if (!count || isFee(item)) return false;
        var props = item.properties || {};
        for (var i = 1; i <= count; i++) {
          if (!props['Cookie Tin ' + i]) return true;
        }
        return false;
      }

      function istNow() {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        var o = {};
        parts.forEach(function (p) { o[p.type] = p.value; });
        return { today: o.year + '-' + o.month + '-' + o.day, minutes: (+o.hour) * 60 + (+o.minute) };
      }

      function addDays(s, n) {
        var p = s.split('-');
        var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n));
        return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
      }

      function pretty(s) {
        var p = s.split('-');
        return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-IN', {
          timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
        });
      }

      function dayLabel(s) {
        var p = s.split('-');
        return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-IN', {
          timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
        });
      }

      function isStale(item) {
        var props = item.properties || {};
        var date = props['_delivery_date'];
        if (isFee(item) || !date) return false;
        var now = istNow();
        if (date < now.today) return true;
        if (date === now.today) {
          if (now.minutes >= 19 * 60) return true;
          if ((props['_delivery_slot'] || '').indexOf('2 PM') === 0 && now.minutes >= 14 * 60) return true;
        }
        return false;
      }

      /* The product page remembers the customer's delivery choice for this tab. */
      function readSelection() {
        try {
          var o = JSON.parse(window.sessionStorage.getItem('omcDelivery') || 'null');
          if (!o || !o.pin || !o.date || !o.slot || !o.type) return null;
          if (Date.now() - (o.ts || 0) > 6 * 60 * 60 * 1000) return null;
          return o;
        } catch (error) {
          return null;
        }
      }

      function selectionValid(o) {
        var now = istNow();
        if (o.date < now.today) return false;
        if (o.date === now.today) {
          if (now.minutes >= 19 * 60) return false;
          if (o.slot.indexOf('2 PM') === 0 && now.minutes >= 14 * 60) return false;
        }
        return true;
      }

      function getCart() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }

      function post(url, body) {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        });
      }

      /* When the cart becomes empty, Dawn needs its "is-empty" flags flipped and the drawer re-rendered,
         otherwise the drawer is left blank. */
      function applyEmptyState(count) {
        var empty = count === 0;
        document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) { el.classList.toggle('is-empty', empty); });
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', empty);
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', empty);
      }

      function refreshSections() {
        return fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function (response) { return response.json(); })
          .then(function (sections) {
            var parser = new DOMParser();
            var drawerHtml = sections['cart-drawer'];
            var drawerTarget = document.getElementById('CartDrawer');
            if (drawerHtml && drawerTarget) {
              var drawerSource = parser.parseFromString(drawerHtml, 'text/html').getElementById('CartDrawer');
              if (drawerSource) drawerTarget.innerHTML = drawerSource.innerHTML;
            }
            var bubbleHtml = sections['cart-icon-bubble'];
            var bubbleTarget = document.getElementById('cart-icon-bubble');
            if (bubbleHtml && bubbleTarget) {
              var bubbleSource = parser.parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
              if (bubbleSource) bubbleTarget.innerHTML = bubbleSource.innerHTML;
            }
          })
          .catch(function () {});
      }

      function notify() {
        return getCart()
          .then(function (cart) {
            applyEmptyState(cart.item_count);
            return refreshSections();
          })
          .then(function () {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'omc-fee' });
            }
            return true;
          })
          .catch(function () { return true; });
      }

      function run() {
        return getCart().then(function (cart) {
          var fees = cart.items.filter(isFee);
          var needFee = cart.items.some(isSameDay);

          if (needFee && fees.length === 0) {
            return post('/cart/add.js', { items: [{ id: FEE_VARIANT, quantity: 1 }] }).then(notify);
          }

          if (needFee) {
            var updates = {};
            var fix = false;
            fees.forEach(function (fee, index) {
              var wanted = index === 0 ? 1 : 0;
              if (fee.quantity !== wanted) { updates[fee.key] = wanted; fix = true; }
            });
            return fix ? post('/cart/update.js', { updates: updates }).then(notify) : false;
          }

          if (fees.length) {
            var removals = {};
            fees.forEach(function (fee) { removals[fee.key] = 0; });
            return post('/cart/update.js', { updates: removals }).then(notify);
          }

          return false;
        });
      }

      /* Safety net: if a freshly added line arrived without its delivery details, attach the remembered choice. */
      function patchNewLine(variantId) {
        var sel = readSelection();
        if (!sel || !selectionValid(sel)) return Promise.resolve(false);
        return getCart().then(function (cart) {
          var line = cart.items.filter(function (item) {
            return !isFee(item) && String(item.variant_id) === String(variantId) && missingDelivery(item);
          })[0];
          if (!line) return false;
          var props = {};
          Object.keys(line.properties || {}).forEach(function (key) { props[key] = line.properties[key]; });
          props['Delivery'] = sel.label || ((sel.type === 'Same Day' ? 'Same-Day' : 'Standard') + ' · ' + dayLabel(sel.date) + ' · ' + sel.slot);
          props['_delivery_type'] = sel.type;
          props['_delivery_pincode'] = sel.pin;
          props['_delivery_slot'] = sel.slot;
          props['_delivery_date'] = sel.date;
          return post('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props }).then(function () { return true; });
        });
      }

      function reconcile() {
        chain = chain.then(run).catch(function () { return false; });
        return chain;
      }

      function showMessage(button, text) {
        var inDrawer = !!button.closest('cart-drawer');
        var target = document.getElementById(inDrawer ? 'CartDrawer-CartErrors' : 'cart-errors');
        if (target) target.textContent = text;
      }

      function guardCheckout(button) {
        reconcile()
          .then(function (changed) {
            return getCart().then(function (cart) {
              var noTins = cart.items.some(missingTins);
              var missing = cart.items.some(missingDelivery);
              var stale = cart.items.some(isStale);
              var fees = cart.items.filter(isFee);
              var needFee = cart.items.some(isSameDay);
              var feeOk = needFee ? fees.length === 1 && fees[0].quantity === 1 : fees.length === 0;

              if (noTins) {
                showMessage(button, 'Please choose the cookie tin flavours for your hamper: remove it and add it again from its page.');
                return;
              }
              if (missing) {
                showMessage(button, 'Please choose a delivery date and slot: remove the item and add it again from its product page.');
                return;
              }
              if (stale) {
                showMessage(button, 'Your delivery date or slot is no longer available. Please remove that item and add it again with a new date and slot.');
                return;
              }
              if (changed || !feeOk) {
                showMessage(button, 'We updated your delivery charge. Please review your cart, then check out again.');
                return;
              }

              showMessage(button, '');
              button.setAttribute('data-omc-ok', '1');
              var form = button.form;
              if (form && form.requestSubmit) { form.requestSubmit(button); } else { button.click(); }
            });
          })
          .catch(function () {
            showMessage(button, 'We could not confirm your delivery charge. Please try again.');
          });
      }

      document.addEventListener('click', function (event) {
        var button = event.target.closest('button[name="checkout"], input[name="checkout"]');
        if (!button || button.getAttribute('data-omc-ok') === '1') return;
        event.preventDefault();
        event.stopPropagation();
        guardCheckout(button);
      }, true);

      function start() {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.source === 'omc-fee') return;
            if (event && event.source === 'product-form' && event.productVariantId) {
              chain = chain
                .then(function () { return patchNewLine(event.productVariantId); })
                .then(function (patched) { return patched ? notify() : false; })
                .catch(function () { return false; });
            }
            reconcile();
          });
        }
        if (location.pathname === '/cart' || location.pathname.indexOf('/cart/') === 0) reconcile();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    })();

/* ---- WhatsApp button steps aside while a call-to-action button is on screen ---- */
    (function () {
      if (window.__omcWhatsapp) return;
      window.__omcWhatsapp = true;

      function start() {
        var button = document.querySelector('.omc-wa');
        if (!button || !('IntersectionObserver' in window)) return;

        var visible = new Set();
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              visible.add(entry.target);
            } else {
              visible.delete(entry.target);
            }
          });
          button.classList.toggle('omc-wa--hide', visible.size > 0);
        }, { threshold: 0.1 });

        document
          .querySelectorAll('.product-form__submit, .cart__checkout-button, .omc-ch__submit, .omc-dc__btn')
          .forEach(function (target) { observer.observe(target); });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    })();

/* ---- delivery date box opens its calendar on desktop ---- */
  (function () {
    if (window.__omcDatePicker) return;
    window.__omcDatePicker = true;

    document.addEventListener('click', function (event) {
      var box = event.target.closest && event.target.closest('.omc-dc__datebox');
      if (!box) return;
      var input = box.querySelector('.omc-dc__date');
      if (!input || input.disabled || typeof input.showPicker !== 'function') return;
      try {
        input.showPicker();
      } catch (error) {}
    });
  })();

/* ---- pincode checker with delivery date and slot ---- */
  (function () {
    if (window.__omcDeliveryChecker) return;
    window.__omcDeliveryChecker = true;

    var SLOTS = ['2 PM – 6 PM', '6 PM – 11 PM'];
    var MORNING_CUTOFF = 14 * 60;
    var EVENING_CUTOFF = 19 * 60;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function istNow() {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return {
        today: o.year + '-' + o.month + '-' + o.day,
        minutes: (+o.hour) * 60 + (+o.minute)
      };
    }

    function addDays(s, n) {
      var p = s.split('-');
      var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n));
      return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
    }

    function pretty(s) {
      var p = s.split('-');
      return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-IN', {
        timeZone: 'UTC',
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }

    function rulesFor(date) {
      var now = istNow();
      if (date < now.today) return { valid: false, slots: [], sameDay: false };
      if (date > now.today) return { valid: true, slots: SLOTS, sameDay: false };
      if (now.minutes >= EVENING_CUTOFF) return { valid: false, slots: [], sameDay: true };
      if (now.minutes >= MORNING_CUTOFF) return { valid: true, slots: [SLOTS[1]], sameDay: true };
      return { valid: true, slots: SLOTS, sameDay: true };
    }

    function earliestDate() {
      var now = istNow();
      return now.minutes >= EVENING_CUTOFF ? addDays(now.today, 1) : now.today;
    }

    function st(root) {
      if (!root._omc) root._omc = { pin: '', date: '', slot: '' };
      return root._omc;
    }

    function isComplete(root) {
      var s = st(root);
      if (!s.pin || !s.date || !s.slot) return false;
      var r = rulesFor(s.date);
      return r.valid && r.slots.indexOf(s.slot) > -1;
    }

    var STORE_KEY = 'omcDelivery';

    function readStored() {
      try {
        var raw = window.sessionStorage.getItem(STORE_KEY);
        if (!raw) return null;
        var o = JSON.parse(raw);
        if (!o || !o.pin || !o.date || !o.slot) return null;
        if (Date.now() - (o.ts || 0) > 6 * 60 * 60 * 1000) return null;
        return o;
      } catch (error) {
        return null;
      }
    }

    function writeStored(root) {
      try {
        var s = st(root);
        var r = rulesFor(s.date);
        window.sessionStorage.setItem(STORE_KEY, JSON.stringify({
          pin: s.pin,
          date: s.date,
          slot: s.slot,
          type: r.sameDay ? 'Same Day' : 'Standard',
          label: labelFor(s.date, s.slot, r.sameDay),
          pretty: pretty(s.date),
          ts: Date.now()
        }));
      } catch (error) {}
    }

    function labelFor(date, slot, sameDay) {
      var p = date.split('-');
      var day = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-IN', {
        timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
      });
      return (sameDay ? 'Same-Day' : 'Standard') + ' · ' + day + ' · ' + slot;
    }

    function shortDate(s) {
      var p = s.split('-');
      return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-IN', {
        timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric'
      });
    }

    function productForm(root) {
      var section = root.closest('.shopify-section');
      if (!section) return null;
      return section.querySelector('product-form form[action*="/cart/add"]') || section.querySelector('form[action*="/cart/add"]');
    }

    function setProp(form, name, value) {
      var input = form.querySelector('input[data-omc-prop="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.setAttribute('data-omc-prop', name);
        form.appendChild(input);
      }
      input.value = value || '';
    }

    function sync(root, explicitForm) {
      var form = explicitForm || productForm(root);
      if (!form) return;
      var s = st(root);
      var ok = isComplete(root);
      var r = s.date ? rulesFor(s.date) : null;
      setProp(form, 'Delivery', ok ? labelFor(s.date, s.slot, r.sameDay) : '');
      setProp(form, '_delivery_type', ok ? (r.sameDay ? 'Same Day' : 'Standard') : '');
      setProp(form, '_delivery_pincode', ok ? s.pin : '');
      setProp(form, '_delivery_slot', ok ? s.slot : '');
      setProp(form, '_delivery_date', ok ? s.date : '');
    }

    function render(root) {
      var box = root.querySelector('.omc-dc__schedule');
      if (!box) return;
      var s = st(root);
      box.hidden = !s.pin;
      if (!s.pin) {
        sync(root);
        return;
      }

      var now = istNow();
      var today = now.today;
      var tomorrow = addDays(today, 1);
      var fee = root.getAttribute('data-fee') || '199';
      var todayRules = rulesFor(today);

      var todayBtn = box.querySelector('[data-day="today"]');
      var tomorrowBtn = box.querySelector('[data-day="tomorrow"]');
      var dateInput = box.querySelector('.omc-dc__date');

      todayBtn.textContent = todayRules.valid ? 'Today (₹' + fee + ')' : 'Today (closed)';
      todayBtn.disabled = !todayRules.valid;
      todayBtn.classList.toggle('is-active', s.date === today);
      tomorrowBtn.classList.toggle('is-active', s.date === tomorrow);

      dateInput.min = earliestDate();
      dateInput.max = addDays(today, 60);
      var customDate = !!(s.date && s.date !== today && s.date !== tomorrow);
      dateInput.value = customDate ? s.date : '';
      var dateText = box.querySelector('.omc-dc__datetext');
      if (dateText) dateText.textContent = customDate ? shortDate(s.date) : 'Choose delivery date';
      var dateBox = box.querySelector('.omc-dc__datebox');
      if (dateBox) dateBox.classList.toggle('is-active', customDate);

      var r = s.date ? rulesFor(s.date) : { slots: [], sameDay: false };
      box.querySelectorAll('[data-slot]').forEach(function (btn) {
        var slot = btn.getAttribute('data-slot');
        var allowed = r.slots.indexOf(slot) > -1;
        btn.disabled = !allowed;
        btn.classList.toggle('is-active', allowed && s.slot === slot);
      });

      var summary = box.querySelector('.omc-dc__summary');
      var note = box.querySelector('.omc-dc__note');
      if (isComplete(root)) {
        summary.textContent = '✓ Delivery on ' + pretty(s.date) + ' · ' + s.slot +
          (r.sameDay ? ' · Same-day charge ₹' + fee : ' · Free delivery');
      } else {
        summary.textContent = s.date ? 'Now choose a time slot.' : 'Choose a delivery date.';
      }
      note.hidden = s.date !== today;
      sync(root);
      if (isComplete(root)) writeStored(root);
    }

    function checkPin(root) {
      var input = root.querySelector('.omc-dc__input');
      var msg = root.querySelector('.omc-dc__msg');
      var wa = root.querySelector('.omc-dc__wa');
      var s = st(root);
      var pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
      input.value = pin;
      root.classList.remove('is-ok', 'is-bad');
      wa.hidden = true;
      s.pin = '';
      s.date = '';
      s.slot = '';

      if (pin.length !== 6) {
        msg.textContent = 'Please enter a valid 6-digit pincode.';
        root.classList.add('is-bad');
        render(root);
        return;
      }

      var list = ',' + root.getAttribute('data-pincodes') + ',';
      if (list.indexOf(',' + pin + ',') > -1) {
        msg.textContent = root.getAttribute('data-ok').replace('{pincode}', pin);
        root.classList.add('is-ok');
        if (root.getAttribute('data-schedule') === 'true') {
          s.pin = pin;
          s.date = earliestDate();
        }
      } else {
        msg.textContent = root.getAttribute('data-bad').replace('{pincode}', pin);
        root.classList.add('is-bad');
        wa.hidden = false;
      }
      render(root);
    }

    function restore(root) {
      if (root.getAttribute('data-schedule') !== 'true') return;
      var sel = readStored();
      if (!sel) return;
      root.querySelector('.omc-dc__input').value = sel.pin;
      checkPin(root);
      var s = st(root);
      if (!s.pin) return;
      var r = rulesFor(sel.date);
      if (r.valid) {
        s.date = sel.date;
        if (r.slots.indexOf(sel.slot) > -1) s.slot = sel.slot;
      }
      render(root);
    }

    function boot() {
      document.querySelectorAll('[data-omc-dc][data-schedule="true"]').forEach(restore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('click', function (event) {
      var pinBtn = event.target.closest('.omc-dc__btn');
      if (pinBtn) {
        checkPin(pinBtn.closest('[data-omc-dc]'));
        return;
      }

      var chip = event.target.closest('.omc-dc__chip');
      if (!chip || chip.disabled) return;
      var root = chip.closest('[data-omc-dc]');
      var s = st(root);
      var day = chip.getAttribute('data-day');
      var slot = chip.getAttribute('data-slot');

      if (day) {
        var today = istNow().today;
        var next = day === 'today' ? today : addDays(today, 1);
        var nextRules = rulesFor(next);
        if (!nextRules.valid) return;
        s.date = next;
        if (nextRules.slots.indexOf(s.slot) === -1) s.slot = '';
      }
      if (slot) s.slot = slot;
      render(root);
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('omc-dc__date')) return;
      var root = input.closest('[data-omc-dc]');
      var s = st(root);
      var value = input.value;
      var valueRules = value ? rulesFor(value) : null;
      if (!valueRules || !valueRules.valid) {
        input.value = '';
        return;
      }
      s.date = value;
      if (valueRules.slots.indexOf(s.slot) === -1) s.slot = '';
      render(root);
    });

    document.addEventListener('input', function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('omc-dc__input')) return;
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      var root = input.closest('[data-omc-dc]');
      var s = st(root);
      if (s.pin && input.value !== s.pin) {
        s.pin = '';
        s.date = '';
        s.slot = '';
        root.classList.remove('is-ok', 'is-bad');
        root.querySelector('.omc-dc__msg').textContent = '';
        render(root);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var target = event.target;
      if (target && target.classList && target.classList.contains('omc-dc__input')) {
        event.preventDefault();
        checkPin(target.closest('[data-omc-dc]'));
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var section = form.closest('.shopify-section');
      var root = section && section.querySelector('[data-omc-dc][data-schedule="true"]');
      if (!root) return;

      if (isComplete(root)) {
        sync(root, form);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      var msg = root.querySelector('.omc-dc__msg');
      msg.textContent = st(root).pin
        ? 'Please choose a delivery date and time slot first.'
        : 'Please check your delivery pincode first.';
      root.classList.remove('is-ok');
      root.classList.add('is-bad');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  })();